import React, { useState, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { Breadcrumbs, Button, DetailDrawer } from "InnoUI/components";
import SC from "./style";
import { useSelector } from "react-redux";
import { AddAdditionalContact, ImagePreview } from "components";
import theme from "theme";
import GeneralInformation from "./GeneralInformation";
import OccupantLevels from "./OccupantLevels";
import { useSearchParams } from "react-router-dom";
import Reports from "./Reports";
import OccupantFilterDropdown from "components/OccupantFilterDropdown";
import { useDispatch } from "react-redux";
import { fetchSIngleProjectAction } from "@store/project/actions";
import InnoIcons from "@InnoIcons/";
import AddEditProjects from "views/AdminSettings/Projects/AddEditProjects";
import LinkProjects from "views/AdminSettings/Projects/LinkProjects";
import AddLevel from "views/AdminSettings/Projects/AddLevel";
import OccupantTab from "views/AdminSettings/Projects/Occupant/OccupantTab";
import AssignUser from "views/AdminSettings/Projects/AssignUser";
import { getNestedAccess, isEmpty } from "utils/helper";
import NewTab from "components/NewTab";
import useIsMobile from "customHook/useIsMobile";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageNotFound from "components/PageNotFound";
import { projectType } from "utils/lookUpTable";

const ProjectGeneralInformation = (props) => {
  const { defaultTab = 0 } = props;

  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;
  const [selectedTab, setSelectedTab] = useState(defaultTab);
  const [selectedSubLevel, setSelectedSubLevel] = useState({});
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectParamId = searchParams.get("projectId");
  const navigate = useNavigate();
  const [levelImage, setLevelImage] = useState();
  const [open, setOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [openButton, setOpenButton] = useState(null);
  const [openDrwer, setOpenDrwer] = useState(false);
  const [openModalView, setOpenModalView] = useState(false);
  const [openAddlevelDrawer, setOpenAddlevelDrawer] = useState(false);
  const [openAddOccupant, setOpenAddOccupant] = useState(false);
  const [openAssignUserDrawer, setopenAssignUserDrawer] = useState(false);
  const [projectLevelCount, setProjectLevelCount] = useState([]);
  const isMobile = useIsMobile();

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );
  const isProjectFetching = useSelector(
    (state) => state?.currentProject?.isFetching || false,
  );
  const projectError = useSelector((state) => state?.currentProject?.error);
  const accessControlData = useSelector(
    (state) => state?.accessControlData?.data || [],
  );

  const authData = useSelector((state) => state?.authdata?.data || null);

  const occupantOption = useSelector((state) =>
    Array.isArray(state?.occupantOption?.data)
      ? state?.occupantOption?.data
      : [],
  );
  // const hasProjectRootAccess =
  //   accessControlData?.projectFolderAccess == 1 ||
  //   accessControlData?.rootLibraryAccess == 1;
  const hasProjectRootAccess = accessControlData?.projectFolderAccess == 1;

  const handleTabChange = (event, newValue) => {
    if (newValue == 0 || newValue == 2) {
      setLevelImage(null);
    }
    setSelectedTab(newValue);
    setSelectedSubLevel({});
  };

  const canAccessReportsTab =
    getNestedAccess(accessControlData, "canAccessReportsTab") == 1;

  const defaultAccessibleTab =
    defaultTab === 2 && !canAccessReportsTab ? 0 : defaultTab;

  useEffect(() => {
    setSelectedTab(defaultAccessibleTab);
  }, [defaultAccessibleTab]);

  const tabData = hasProjectRootAccess
    ? [
        { value: 0, label: "General Information" },
        { value: 1, label: "Levels" },
        ...(canAccessReportsTab ? [{ value: 2, label: "Reports" }] : []),
      ]
    : [{ value: 1, label: "Levels" }];

  useEffect(() => {
    const projectId = !isEmpty(projectParamId)
      ? projectParamId
      : currentProject?.id;
    if (projectId) {
      dispatch(fetchSIngleProjectAction(projectId));
    }
  }, [currentProject?.id, dispatch, projectParamId]);

  const requestedProjectId = !isEmpty(projectParamId)
    ? projectParamId
    : currentProject?.id;
  const isPropertyRoute =
    isEmpty(type) || type === String(projectType.property);
  const hasValidProjectId = !isEmpty(requestedProjectId);
  const isRequestedProjectLoaded =
    currentProject?.id &&
    String(currentProject.id) === String(requestedProjectId);

  useEffect(() => {
    if (hasProjectRootAccess) {
      setSelectedTab(defaultAccessibleTab);
      return;
    }
    if (
      (occupantOption.length > 1 &&
        accessControlData.projectFolderAccess == undefined) ||
      (null && authData.userType == 2)
    ) {
      setSelectedTab(1);
    }
  }, [accessControlData, defaultAccessibleTab, hasProjectRootAccess]);

  // const celltab = accessControlData.projectFolderAccess == 1 ? 0 : 1;

  const breadcrumbItems = useMemo(() => {
    const baseItems = [
      {
        label: `${currentProject.propertyName || ""}`,
        href: `/project-home`,
      },
    ];

    // Add the dynamic breadcrumb for sub-levels
    if (selectedTab == 1) {
      return [
        ...baseItems,
        { label: "Levels" },
        { label: selectedSubLevel?.label },
      ];
    }
    if (selectedTab === 2) {
      return [
        ...baseItems,
        { label: "Report" },
        { label: selectedSubLevel?.label },
      ];
    }
    switch (selectedTab) {
      case 2:
        return [...baseItems, { label: "Reports" }];
      default:
        return [...baseItems, { label: "General Information" }];
    }
  }, [currentProject, selectedTab, selectedSubLevel]);

  const closeAssignUserDrawer = () => {
    setopenAssignUserDrawer(false);
    setIsEditing(false);
    setOpenButton(null);
  };

  const closeOccupantDrawer = () => {
    setOpenAddOccupant(false);
    setOpenButton(null);
  };

  const handleOccupant = (record) => {
    setOpenAddOccupant(true);
  };

  const closeAddLevelDrawer = () => {
    setOpenAddlevelDrawer(false);
    setIsEditing(false);
    setOpenButton(null);
  };

  const editAddLevelDrawer = () => {
    setOpenAddlevelDrawer(true);
    setIsEditing(true);
    // setOpenButton(null);
  };

  const handleOpenAddLevelDrawer = () => {
    setOpenAddlevelDrawer(true);
  };

  const handleAddUser = () => {
    // setOpenModalView(true);
    // setopenAssignUserDrawer(true);
    navigate(`/address-book?projectId=${currentProject.id}&type=0`);
  };

  const handleCloseModal = () => {
    setOpenModalView(false);
    setOpenButton(null);
  };

  const closeLinkProjectDrawer = () => {
    setOpenDrwer(false);
    // setRowData(null);
    setOpenButton(null);
  };

  const handleLinkProjects = (record) => {
    setOpenDrwer(true);
    // setRowData(record);
  };

  const closeDrawer = () => {
    setOpen(false);
    setIsEditing(false);
    setOpenButton(null);
  };

  const handleEditProject = () => {
    setOpen(true);
    setIsEditing(true);
  };

  const actionButtons = [
    {
      key: "edit",
      caption: "Edit Details",
      icon: (isActive) => (
        <InnoIcons.EditIcon
          sx={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleEditProject,
      accessKey: "canEditProject",
    },
    {
      key: "linkHoliday",
      caption: "Link Holiday",
      icon: (isActive) => (
        <InnoIcons.LinkOutlined
          style={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleLinkProjects,
      accessKey: "canLinkHolidayToProject",
    },
    {
      key: "addUser",
      caption: "Manage Users",
      icon: (isActive) => (
        <InnoIcons.AddIcon
          sx={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleAddUser,
      accessKey: "canAddUserToProject",
    },
  ];

  const actionButtonLevel = [
    {
      key: "newLevel",
      caption: "New Level",
      icon: (isActive) => (
        <InnoIcons.AddIcon
          sx={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleOpenAddLevelDrawer,
      accessKey: "canAddLevel",
    },
    {
      key: "editLevel",
      caption: "Edit Level",
      icon: (isActive) => (
        <InnoIcons.EditIcon
          style={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: editAddLevelDrawer,
      accessKey: "canEditLevel",
      disabled: () => projectLevelCount.length == 0,
    },
    {
      key: "newOccupant",
      caption: "New Occupant",
      icon: (isActive) => (
        <InnoIcons.AddIcon
          sx={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleOccupant,
      accessKey: "canAddOccupant",
      disabled: () => projectLevelCount.length == 0,
    },
  ];

  function transformData(input) {
    return {
      id: input?.value,
      name: input?.label,
      image: input?.image,
    };
  }
  const transformedData = transformData(selectedSubLevel);

  useEffect(() => {
    if (isMobile) {
      toast.info(
        "For a better experience, please rotate your device or switch to desktop mode.",
        {
          position: "top-center",
          autoClose: 10000,
          style: {
            background: theme.colors.themeColor,
            color: "white",
          },
        },
      );
    }
  }, [isMobile]);

  if (!isPropertyRoute) {
    return (
      <PageNotFound
        heading="Invalid project link"
        message="This page needs a project URL. Please open a project with type=0."
      />
    );
  }

  if (!hasValidProjectId) {
    return (
      <PageNotFound
        heading="Project not found"
        message="The project link is missing a valid project id."
      />
    );
  }

  if (!isRequestedProjectLoaded) {
    if (isProjectFetching && !projectError) {
      return (
        <div style={{ padding: "140px 32px", textAlign: "center" }}>
          Loading project...
        </div>
      );
    }

    return (
      <PageNotFound
        heading="Project not found"
        message="The project link is invalid or this project is not available for your account."
      />
    );
  }

  return (
    <>
      <ToastContainer />
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={currentPath}
      />
      <SC.BodyContainer>
        <SC.FilterContainer>
          <OccupantFilterDropdown />
        </SC.FilterContainer>
        <SC.Container>
          <SC.ActiveContainer>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                gap: "10px",
              }}
            >
              <SC.ImageContainer>
                <SC.Image>
                  <ImagePreview
                    src={currentProject.logoImage}
                    height="100%"
                    width="100%"
                    style={{ objectFit: "contain" }}
                  />
                </SC.Image>
              </SC.ImageContainer>
              <SC.ProjectDiv>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "0px",
                      }}
                    >
                      <SC.PropertyName>
                        {currentProject.propertyName}
                      </SC.PropertyName>
                      <SC.Status currentProject={currentProject}>
                        {currentProject.status === 1 ? "Active" : "Inactive"}
                      </SC.Status>
                    </div>
                    {currentProject.email && (
                      <SC.Email>{currentProject.email}</SC.Email>
                    )}
                  </div>
                  <SC.ImageContainer style={{ marginLeft: "24px" }}>
                    <SC.Image>
                      <ImagePreview
                        src={
                          selectedTab === 1
                            ? levelImage
                            : currentProject.displayImage
                        }
                        height="100%"
                        width="100%"
                        style={{ objectFit: "contain" }}
                      />
                    </SC.Image>
                  </SC.ImageContainer>
                </div>
              </SC.ProjectDiv>
            </div>
          </SC.ActiveContainer>

          <SC.TabContainer>
            <NewTab
              tabs={tabData}
              onChange={handleTabChange}
              selectedValue={selectedTab}
            />
          </SC.TabContainer>

          {selectedTab === 0 && (
            <SC.ButtonContaiiner>
              {actionButtons
                .filter((btn) =>
                  getNestedAccess(accessControlData, btn.accessKey),
                )
                .map((btn) => {
                  const isActive = openButton === btn.key;
                  return (
                    <Button
                      key={btn.key}
                      leftIcon={btn.icon(isActive)}
                      caption={btn.caption}
                      fontSize="12px"
                      color={isActive ? "white" : theme.colors.themeColor}
                      onClick={() => {
                        setOpenButton(btn.key);
                        btn.onClick();
                      }}
                      style={{
                        background: isActive
                          ? theme.gradient.themeGradient
                          : "rgba(255, 255, 255, 0.9)",
                        minWidth: "120px",
                        borderRadius: "12px",
                        height: "40px",
                        fontSize: "13px",
                        border: `1px solid ${
                          isActive
                            ? "rgba(255, 255, 255, 0.2)"
                            : "rgba(227, 110, 0, 0.2)"
                        }`,
                        boxShadow: isActive
                          ? "0 4px 15px rgba(227, 110, 0, 0.3)"
                          : "0 2px 8px rgba(0, 0, 0, 0.05)",
                        transition: "all 0.3s ease",
                        backdropFilter: "blur(10px)",
                      }}
                    />
                  );
                })}
            </SC.ButtonContaiiner>
          )}

          {selectedTab === 1 && (
            <SC.ButtonContaiiner>
              {actionButtonLevel
                .filter((btn) =>
                  getNestedAccess(accessControlData, btn.accessKey),
                )
                .map((btn) => {
                  const isActive = openButton === btn.key;
                  const isDisabled =
                    typeof btn.disabled === "function"
                      ? btn.disabled()
                      : btn.disabled;
                  return (
                    <Button
                      key={btn.key}
                      leftIcon={btn.icon(isActive)}
                      caption={btn.caption}
                      fontSize="12px"
                      color={
                        isActive
                          ? "white"
                          : isDisabled
                            ? "#9ca3af"
                            : theme.colors.themeColor
                      }
                      onClick={() => {
                        setOpenButton(btn.key);
                        btn.onClick();
                      }}
                      disabled={isDisabled}
                      style={{
                        background: isDisabled
                          ? "rgba(156, 163, 175, 0.1)"
                          : isActive
                            ? theme.gradient.themeGradient
                            : "rgba(255, 255, 255, 0.9)",
                        minWidth: "120px",
                        borderRadius: "12px",
                        height: "40px",
                        fontSize: "13px",
                        border: `1px solid ${
                          isDisabled
                            ? "rgba(156, 163, 175, 0.2)"
                            : isActive
                              ? "rgba(255, 255, 255, 0.2)"
                              : "rgba(227, 110, 0, 0.2)"
                        }`,
                        boxShadow: isActive
                          ? "0 4px 15px rgba(227, 110, 0, 0.3)"
                          : "0 2px 8px rgba(0, 0, 0, 0.05)",
                        transition: "all 0.3s ease",
                        backdropFilter: "blur(10px)",
                      }}
                    />
                  );
                })}
            </SC.ButtonContaiiner>
          )}

          {selectedTab === 0 && (
            <div style={{ borderTop: `1px solid ${theme.colors.bordertask}` }}>
              {hasProjectRootAccess ? (
                <GeneralInformation />
              ) : (
                <OccupantLevels
                  setSelectedSubLevel={setSelectedSubLevel}
                  selectedSubLevel={selectedSubLevel}
                  setLevelImage={setLevelImage}
                />
              )}
            </div>
          )}
          {selectedTab === 1 && (
            <div style={{ borderTop: `1px solid ${theme.colors.bordertask}` }}>
              <OccupantLevels
                setSelectedSubLevel={setSelectedSubLevel}
                selectedSubLevel={selectedSubLevel}
                setLevelImage={setLevelImage}
                setProjectLevelCount={setProjectLevelCount}
              />
            </div>
          )}
          {selectedTab === 2 && (
            <div style={{ borderTop: `1px solid ${theme.colors.bordertask}` }}>
              <Reports
                setSelectedSubLevel={setSelectedSubLevel}
                selectedSubLevel={selectedSubLevel}
              />
            </div>
          )}
        </SC.Container>
      </SC.BodyContainer>

      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          width={"650px"}
          children={
            <AddEditProjects
              projectdata={currentProject}
              onClose={closeDrawer}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              rowId={currentProject.id}
              reload={true}
              // setProjects={setProjects}
              // fetchData={getAllProjects}
            />
          }
        />
      )}

      {openDrwer && (
        <DetailDrawer
          open={openDrwer}
          onClose={closeLinkProjectDrawer}
          title={false}
          width={"650px"}
          children={
            <LinkProjects
              onClose={closeLinkProjectDrawer}
              projectData={currentProject}
              // setSelectedItem={setSelectedItems}
              // fetchData={getAllProjects}
              setOpenDrwer={setOpenDrwer}
            />
          }
        />
      )}

      {openModalView && (
        <AddAdditionalContact
          openModalView={openModalView}
          onClose={handleCloseModal}
          createTO={true}
          // setPropData={setData}
        />
      )}

      {openAddlevelDrawer && (
        <DetailDrawer
          open={openAddlevelDrawer}
          onClose={closeAddLevelDrawer}
          title={false}
          width={"650px"}
          children={
            <AddLevel
              projectdata={transformedData}
              onClose={closeAddLevelDrawer}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              // rowId={selectedSubLevel.value}
              projectId={currentProject.id}
              // setProjects={setProjects}
              reload={false}
              setSelectedTab={setSelectedTab}
            />
          }
        />
      )}

      {openAddOccupant && (
        <DetailDrawer
          open={openAddOccupant}
          onClose={closeOccupantDrawer}
          title={false}
          width={"700px"}
          children={
            <OccupantTab
              // occupantdata={rowData}
              // levelId={rowAllData.id}
              Projectdata={currentProject}
              onClose={closeOccupantDrawer}
              // fetchData={getAllOccupant}
              // rowId={rowId}
              isInfo={false}
              // setOccupant={setOccupant}
              isLevel={true}
              setSelectedTabb={setSelectedTab}
            />
          }
        />
      )}

      {openAssignUserDrawer && (
        <DetailDrawer
          open={openAssignUserDrawer}
          onClose={closeAssignUserDrawer}
          width={"70%"}
          children={
            <AssignUser
              // userdata={fieldData}
              onClose={closeAssignUserDrawer}
              project={currentProject}
              // fetchData={getAlldata}
              hideColumns={["cell", "userType", "createdAt", "roleNames"]}
              isDisabled={true}
            />
          }
        />
      )}
    </>
  );
};

export default ProjectGeneralInformation;
